import {v4 as uuid} from 'uuid';

export class DataHelper {

  public static generateId(): string {
    return uuid();
  }

  public static generateTmpId(): string {
    return '_' + Math.random().toString(36).substr(2, 9);
  }

  public static isAutoGeneratedId(id?: string): boolean {
    return id != undefined && id.startsWith('_');
  }

  public static downloadFile(url: string) {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank';
    // a.download = file_path.substr(file_path.lastIndexOf('/') + 1);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

}
